<template>
  <div
    v-if="showPresets"
    class="d-flex align-center justify-start presets"
  >
    <DatePickerPresetSelect
      v-if="formattedPresets.daysRange"
      :is-selected="selectedRange.category === 'daysRange'"
      :date-range="formattedPresets.daysRange"
      :selected-preset="selectedRange.range"
      @update:model-value="($event) => $emit('update:model-value', $event)"
    />
    <DatePickerPresetSelect
      v-if="formattedPresets.thisRange"
      :is-selected="selectedRange.category === 'thisRange'"
      :date-range="formattedPresets.thisRange"
      :selected-preset="selectedRange.range"
      :default-range="defaultRange?.category === 'thisRange' ? defaultRange.range : {}"
      @update:model-value="($event) => $emit('update:model-value', $event)"
    />
    <DatePickerPresetSelect
      v-if="formattedPresets.lastRange"
      :is-selected="selectedRange.category === 'lastRange'"
      :date-range="formattedPresets.lastRange"
      :selected-preset="selectedRange.range"
      :default-range="defaultRange?.category === 'lastRange' ? defaultRange.range : {}"
      :is-last-item="!isWeekDisplay"
      @update:model-value="($event) => $emit('update:model-value', $event)"
    />
    <DatePickerPresetSelect
      v-if="formattedPresets.previousRange"
      :is-selected="selectedRange.category === 'previousRange'"
      :date-range="formattedPresets.previousRange"
      :selected-preset="selectedRange.range"
      :is-last-item="isWeekDisplay"
      @update:model-value="($event) => $emit('update:model-value', $event)"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DatePickerPresetSelect from '@/components/filter/dateFilters/DatePicker/DatePickerPresetSelect.vue';

const props = defineProps([
  'modelValue', 'formattedPresets', 'selectedRange', 'defaultRange',
]);
defineEmits(['update:model-value']);

const showPresets = computed(() => Object.keys(props.formattedPresets).length);

const isWeekDisplay = computed(() => Boolean(props.formattedPresets?.previousRange));
</script>
